// extracted by mini-css-extract-plugin
export var blockchainButton = "MiXwj6M29oRA_VHsyo7v";
export var blockchainName = "yHX5Iep04OnXGMII0VJQ";
export var blockchainOption = "DJBNf3pck8h_uaPbpHr9";
export var blockchainOptionIcon = "uFwCH2ZDXHamlkzjSFfP";